export enum ProposalLanguage {
  English = `en`,
  Spanish = `es`,
}
